<template>
  <div class="my-5">
    <h3 class="mb-5">Histórico</h3>
    <div class="history-group">
      <app-item
        class="history-item mb-3"
        v-for="(item, index) in getHistory"
        :key="index"
        :item="item"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "appHistory",
  data() {
    return {};
  },
  computed: {
    getHistory() {
      return this.$store.getters["history/getHistory"];
    }
  },
  components: {
    appItem: () => import("./Item")
  }
};
</script>

<style scoped>
.history-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.history-item {
  max-width: 340px;
  margin: 0px 10px;
}
</style>